import { createClient } from '@supabase/supabase-js';

// ═══════════════════════════════════════════════════════
// INSTRUÇÕES:
// 1. Acesse https://supabase.com → seu projeto → Settings → API
// 2. Copie a "Project URL" e cole no lugar de 'SUA_URL_AQUI'
// 3. Copie a "anon public key" e cole no lugar de 'SUA_CHAVE_AQUI'
// ═══════════════════════════════════════════════════════

const supabaseUrl = 'SUA_URL_AQUI';
// Exemplo real: 'https://abcdef123456.supabase.co'

const supabaseAnonKey = 'SUA_CHAVE_AQUI';
// Exemplo real: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3...'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);